import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";

function* editBundle(action) {
    try {
        const { bundle, refreshData } = action.payload;

        yield call(() => gamesAPI.editBundle(bundle));
        ToasterService.successToast("Bundle successfully edited");

        yield put({
            type: GamesActionTypes.EDIT_BUNDLE_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_BUNDLES,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error saving Bundle.");

        yield put({
            type: GamesActionTypes.EDIT_BUNDLE_FAIL,
            message: e.message
        });
    }
}

export function* editBundleWatcher() {
    yield takeLatest(GamesActionTypes.EDIT_BUNDLE, editBundle);
}

function* createBundle(action) {
    try {
        const { bundle, refreshData } = action.payload;

        yield call(() => gamesAPI.createBundle(bundle));
        ToasterService.successToast("Bundle successfully created");

        yield put({
            type: GamesActionTypes.CREATE_BUNDLE_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_BUNDLES,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error saving Bundle.");

        yield put({
            type: GamesActionTypes.CREATE_BUNDLE_FAIL,
            message: e.message
        });
    }
}

export function* createBundleWatcher() {
    yield takeLatest(GamesActionTypes.CREATE_BUNDLE, createBundle);
}

function* deleteBundle(action) {
    try {
        const { id, refreshData } = action.payload;

        yield call(() => gamesAPI.deleteBundle(id));
        ToasterService.successToast("Bundle successfully deleted");

        yield put({
            type: GamesActionTypes.DELETE_BUNDLE_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_BUNDLES,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error deleting Bundle.");

        yield put({
            type: GamesActionTypes.DELETE_BUNDLE_FAIL,
            message: e.message
        });
    }
}

export function* deleteBundleWatcher() {
    yield takeLatest(GamesActionTypes.DELETE_BUNDLE, deleteBundle);
}
